import {Injectable, Injector} from '@angular/core';
import {MessageService} from "primeng/api";

enum AppMessageType {
  success,
  warning,
  error,
  information
}


@Injectable({providedIn: 'root'})
export class AppMessageService {
  constructor(protected injector: Injector, protected messageService: MessageService) {
  }

  public getMessageService(): MessageService {
    return this.messageService;
  }

  public getMessageTypeString(messageType: AppMessageType) : string {

    switch (messageType) {
      case AppMessageType.error:
        return 'error';
        break;
      case AppMessageType.information:
        return 'info';
        break;
      case AppMessageType.success:
        return 'success';
        break;
      case AppMessageType.warning:
        return 'warn';
        break;
    }

  }

  public showSuccessMessageSaved() {
    this.showMessage(AppMessageType.success, "Speicherung", "Daten wurden erfolgreich gespeichert.");
  }

  public showSuccessMessage(title: string, message: string) {
    this.showMessage(AppMessageType.success, title, message);
  }

  public showInfoMessage(title: string, message: string) {
    this.showMessage(AppMessageType.information, title, message);
  }

  public showWarningMessage(title: string, message: string) {
    this.showMessage(AppMessageType.warning, title, message);
  }

  public showErrorMessage(title: string, message: string) {
    this.showMessage(AppMessageType.error, title, message);
  }


  public showMessage(messageType: AppMessageType, title: string, message: string) {

    let messageTypeString = this.getMessageTypeString(messageType);

    this.messageService.add({severity:messageTypeString, summary: title, detail: message});

  }




}
